<template>
  <div v-if="live.id">
    <div class="live__container">
      <div
        v-if="live.is_premium"
        class="row justify-content-center"
      >
        <div class="col-8">
            <LiveVideoPlayer
              v-if="live && isLogged"
              :live="live"
            />
        </div>
      </div>
      
      <div
        v-else
        class="row no-gutters"
      >
        <div class="col-lg-9 pr-lg-2">
          <!-- <PrimarySectionTitle class="mb-4 pr-4 pl-4 p-sm-0 d-block d-lg-none">
            <h2>{{ live.name }}</h2>
            <h3>com <b>{{ live.user.name }}</b></h3>
          </PrimarySectionTitle> -->

          <LiveVideoPlayer
            v-if="live && isLogged"
            :live="live"
          />

          <CourseVideoThumb
            v-else
            :thumb="live.thumb_url"
            :hasHover="false"
          />
        </div>
        
        <div class="col-lg-3 mb-lg-0">
          <ChatLive
            :live="live"
            :user="user"
            :token="token"
          />
        </div>
      </div>

      <LivePrimaryInfo
        v-if="!live.is_premium"
        :live="live"
      />
    </div>

    <div
      class="container-bg"
      v-if="!live.is_started"
    >
      <ContainerMedium>
        <LiveReminderBox />
      </ContainerMedium>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import PrimarySectionTitle from '@/components/layout/PrimarySectionTitle'
  import LiveVideoPlayer from '@/components/live/LiveVideoPlayer'
  import ContainerMedium from '@/components/layout/containers/ContainerMedium'
  import LiveReminderBox from '@/components/live/LiveReminderBox'
  import AuthorAboutBox from '@/components/user/AuthorAboutBox'
  import CourseDescriptionText from '@/components/text/course/CourseDescriptionText'
  import CourseVideoThumb from '@/components/course/CourseVideoThumb'
  import ChatLive from '@/components/chat/ChatLive'
  import LivePrimaryInfo from '@/components/live/LivePrimaryInfo'

  export default {
    metaInfo () {
      return {
        title: `Live ${this.live.name} | CyberClass`,
        meta: [
          { property: 'description', content: this.live.description },
        ]
      }
    },
    components: {
      LiveVideoPlayer,
      ChatLive,
      PrimarySectionTitle,
      ContainerMedium,
      LiveReminderBox,
      AuthorAboutBox,
      CourseDescriptionText,
      CourseVideoThumb,
      LivePrimaryInfo,
    },
    async mounted () {
      const liveId = this.$route.params.id

      this.$store.commit('app/setLoading', true)

      try {
        await this.$store.dispatch('live/fetchLive', liveId)
        this.$store.commit('app/setLoading', false)
      } catch (err) {
        this.$store.commit('app/setLoading', false)
        this.$router.replace('/')
      }

      if (this.live.is_premium && !this.hasUserSubscriptionAccess) {
        this.$router.replace('/')
      }
    },
    computed: {
      ...mapGetters('live', ['live']),

      ...mapGetters('user', ['isLogged', 'user', 'token', 'hasUserSubscriptionAccess']),
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .container-bg {
    padding: 40px 0;
    background-color: rgba($highlightPrimaryColor, .85);
  }

  .live {
    &__container {
      padding: 0 30px;
      background: #EDEDED;

      @media (max-width: 992px) {
        padding-left: 0;
        padding-right: 0;
      }
    }

  }
</style>